import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

interface BankCredentialsState {
  modalClosable: boolean;
  credentialId?: number;
  customerCredentialList?: any;
  activeProvider?: "unnax" | "tink";
  widgetUrl?: string;
  loading?: boolean;
}

const initialState: BankCredentialsState = {
  modalClosable: false,
  loading: false
};

const bankCredentialsSlice = createSlice({
  name: "bankCredentials",
  initialState,
  reducers: {
    changeModalClosableState(state, action: PayloadAction<boolean>) {
      state.modalClosable = action.payload;
    },
    chooseCredential(state, action) {
      state.credentialId = action.payload;
    },
    passCustomerCredentialList(state, action) {
      state.customerCredentialList = action.payload;
    },
    getActiveProvider(state, action) {
      state.activeProvider = action.payload;
    },
    initializeWidgetModal(state, action) {
      state.modalClosable = false;
    },
    passWidgetUrl(state, action: PayloadAction<string>) {
      state.widgetUrl = action.payload;
    },
    toggleLoadingStatus(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    tinkWidgetFinished(state) {
      return state;
    },
    sendWidgetEvents: {
      reducer: (state, action: PayloadAction<any>) => {
        return state;
      },
      prepare: (widgetPayload, widgetProvider) => {
        return {
          payload: {
            widgetPayload,
            widgetProvider
          }
        };
      }
    },
    initializeDeclineScrapeWidget(state) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});

export default bankCredentialsSlice.reducer;
export const {
  changeModalClosableState,
  chooseCredential,
  passCustomerCredentialList,
  getActiveProvider,
  initializeWidgetModal,
  passWidgetUrl,
  sendWidgetEvents,
  initializeDeclineScrapeWidget,
  destroy
} = bankCredentialsSlice.actions;
export const bankCredentialsActions = bankCredentialsSlice.actions;
